import type { BacktestFormState } from "./types.ts";

export const strategyPresets = [
  { name: "MA Cross", style: "Trend", summary: "Fast/slow moving average crossover." },
  { name: "Pullback", style: "Trend", summary: "Buy recovery near the fast moving average." },
  { name: "Breakout", style: "Momentum", summary: "Buy previous high breakouts." },
  { name: "Engulfing", style: "Price Action", summary: "Buy bullish engulfing reversals." },
  { name: "Pin Bar", style: "Price Action", summary: "Buy bullish pin bar reversals." },
  { name: "Inside Bar", style: "Price Action", summary: "Buy inside bar breakouts." },
  { name: "Sweep", style: "Price Action", summary: "Buy liquidity sweep reclaims." },
  { name: "RSI", style: "Mean Reversion", summary: "Buy oversold RSI recoveries." },
  { name: "Bollinger", style: "Mean Reversion", summary: "Buy lower-band recoveries." },
  { name: "MACD", style: "Momentum", summary: "Trade MACD signal crosses." },
  { name: "Trend+", style: "Composite", summary: "EMA trend, RSI recovery, MACD momentum, ATR risk." },
  { name: "Vol Break", style: "Composite", summary: "Breakout confirmed by volume and ATR." },
  { name: "Mean+", style: "Composite", summary: "RSI reversion with EMA and ATR filters." },
  { name: "MTF", style: "Composite", summary: "Long EMA trend with short EMA timing." },
] as const;

export type StrategyPresetName = (typeof strategyPresets)[number]["name"];
export const DEFAULT_STRATEGY_PRESET: StrategyPresetName = "MACD";

const strategyPresetNameSet = new Set<string>(strategyPresets.map((preset) => preset.name));

export function isStrategyPresetName(value: string | undefined): value is StrategyPresetName {
  return Boolean(value && strategyPresetNameSet.has(value));
}

/**
 * Selecting a product preset is one state transition. In particular, it must
 * not retain a previously applied visual-Builder route or DSL payload.
 */
export function selectStrategyPreset(
  current: BacktestFormState,
  strategyName: StrategyPresetName,
): BacktestFormState {
  return {
    ...current,
    strategyMode: "auto",
    strategyName,
    strategyDSL: undefined,
    strategyMethod: undefined, unsupportedMethodExecution: undefined,
    useAI: false,
  };
}
